<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import ICountUp from "vue-countup-v2";
import appConfig from "@/app.config";
import axios from 'axios';
/**
 * Dashboard component
 */
export default {
  name: "home",
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ICountUp,
  },
  data() {
    return {
      title: "Dashboard",
      allUsers: 0,
      start_date: "",
      end_date: "",
      lastMonthUsers: 0,
      lastWeekUsers: 0,
      allOrders: 0,
      lastMonthOrders: 0,
      lastWeekOrders: 0,
      delay: 0,
      filterOrders: 0,
      options: {
        useEasing: true,
        useGrouping: true,
      },
      orderList: [],
      selectedOrder: null,
    };
  },
  methods: {
    fetchData() {
      let that = this;
      let url = process.env.VUE_APP_BASE_URL + `/api/Dashboard/${appConfig.dashboard.users_orders}`;
      axios.get(url).then(function (response) {
        console.log(response);
        // Users
        that.allUsers = response.data.userCount;
        that.lastMonthUsers = response.data.user_last_month_count;
        that.lastWeekUsers = response.data.user_last_week_count;
        // Orders
        that.allOrders = response.data.allOrders;
        that.lastMonthOrders = response.data.lastMonthOrders;
        that.lastWeekOrders = response.data.lastWeekOrders;
      });
      // "list_form" : "/report/forms",
      // "filter" : "/count/order/",
    },
    fetchOrders() {
      let that =this;
      let url = process.env.VUE_APP_BASE_URL + `/api/Services/list`;
      axios.get(url).then(function(response)
      {
        that.orderList = response.data;
        that.filterOrders = that.allOrders;
      });
    },
    onChangeSelect(event) {
      console.log(event)
      let that = this;
      if (that.end_date && that.start_date) {
        let to = new Date(that.end_date);
        to.setDate(to.getDate() + 1);
        let from = new Date(that.start_date);
        let url = process.env.VUE_APP_BASE_URL + `/api/Dashboard/filter_order`;
        let queryParams = {
          id: that.selectedOrder ?? '',
          from: from,
          to: to
        };
        axios.get(url, { params: queryParams }).then(function (response) {
          that.filterOrders = response.data.orders;
        });
      }
    },
    toISOWithOffset(date) {
      let offset = 2 * 60;
      let timezoneOffset = date.getTimezoneOffset();
      let adjustedDate = new Date(date.getTime() - (timezoneOffset * 60000));
      let isoString = adjustedDate.toISOString().slice(0, 19);

      let sign = offset >= 0 ? '+' : '-';
      let hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
      let minutes = String(Math.abs(offset) % 60).padStart(2, '0');
      let formattedOffset = `${sign}${hours}:${minutes}`;

      return `${isoString}${formattedOffset}`;
    }
  },
  mounted() {
    this.fetchData();
    this.fetchOrders();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-xl-12">
        <div class="row">
          <!-- ==================== USERS ==================== -->
          <!-- all users -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">Total Users</p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay" :endVal="allUsers" :options="options" />
                      <div class="unit">Users</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-team-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- last month users -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Total Users Of Last Month
                    </p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 300" :endVal="lastMonthUsers" :options="options" />
                      <div class="unit">Users</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-team-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- last week users -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Total Users Of Last Week
                    </p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 600" :endVal="lastWeekUsers" :options="options" />
                      <div class="unit">Users</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-team-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ==================== ORDERS ==================== -->
          <!-- all orders -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">Total Orders</p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 900" :endVal="allOrders" :options="options" />
                      <div class="unit">Orders</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-stack-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- last month orders -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Total Orders Of Last Month
                    </p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 1100" :endVal="lastMonthOrders" :options="options" />
                      <div class="unit">Orders</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-stack-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- last week orders -->
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Total Orders Of Last Week
                    </p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 1400" :endVal="lastWeekOrders" :options="options" />
                      <div class="unit">Orders</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-stack-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Filter Order -->
          <hr />
          <div class="col-md-12">
            <div class="row filter_order">
              <div class="col-md-4 select_order">
                <label>Select Order</label>
                <select class="custom-select custom-select-sm" v-model="selectedOrder" @change="onChangeSelect($event)">
                  <option value="null">
                    All
                  </option>
                  <option v-for="(item, i) in orderList" v-bind:value="item.id" :key="i">
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- Start Date -->
              <div class="col-md-4 form-group mb-3">
                <b-form-group id="label-date" label-cols-sm="3" label-cols-lg="3" label="Start Date"
                  label-for="start-date">
                  <b-form-input v-model="start_date" @change="onChangeSelect($event)" id="start-date" value="2019-08-19"
                    type="date">
                  </b-form-input>
                </b-form-group>
              </div>
              <!-- End Date -->
              <div class="col-md-4 form-group mb-3">
                <div class="form-group mb-3">
                  <b-form-group id="label-end-date" label-cols-sm="3" label-cols-lg="3" label="End Date"
                    label-for="end-date">
                    <b-form-input id="end-date" v-model="end_date" @change="onChangeSelect($event)" value="2019-08-19"
                      type="date">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter Admin -->
          <!-- all orders -->
          <div class="col-md-6">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">Total Orders</p>
                    <h4 class="mb-0">
                      <ICountUp :delay="delay + 900" :endVal="filterOrders" :options="options" />
                      <div class="unit">Orders</div>
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-stack-line font-size-24"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
        <!-- end row -->
      </div>
    </div>
  </Layout>
</template>
<style scoped>
div.unit {
  display: inline-flex;
  position: absolute;
  right: 2%;
  font-size: 1rem;
  bottom: 20%;
  color: #5664d2;
}

hr {
  width: 98%;
}

.filter_order {
  margin-bottom: 1rem;
}

.filter_order label,
label.col-form-label {
  width: 30%;
  display: inline-block;
}

select {
  display: inline-block;
  width: 68%;
  height: 38px;
}

input.form-control {
  display: inline-block;
  width: 98%;
}
</style>
